// extracted by mini-css-extract-plugin
export default {"teamSection":"team-section_teamSection__A9Vaf","teamimage":"team-section_teamimage__Crk9w","logo":"team-section_logo__EcW9s"};